import { Component, NgZone, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { Geolocation } from '@capacitor/geolocation';
import { Circle, GoogleMap, Polyline } from '@capacitor/google-maps';
import { environment  } from 'src/environments/environment';
import { CommonapiService } from '../../../Service/Commonapi.service';
import { Common } from  '../../../Utility/Common';
import { Capacitor } from '@capacitor/core';
import { CustomerapiService } from 'src/app/Module/Shared/Service/Customerapi.service';
import { CustomerService } from 'src/app/Module/Core/Customer/Customer.service';
import { CustomerDetailService } from 'src/app/Module/Core/CustomerDetail/CustomerDetail.service';


@Component({

  selector: 'app-CTDigipinMap',
  templateUrl: './CTDigipinMap.component.html'
})

export class CTDigipinMapComponent  implements OnInit, OnDestroy {
  @ViewChild('digipinmap')
  digipinmapRef: ElementRef<HTMLElement>;
  digipinnewMap: GoogleMap;

  
  showLocationError:boolean = false;
  btnSaveDisableEnable:boolean = false;
  isUseMyLocationClicked:boolean = false;
  divbeyondPopup = false;
  _show = false;
  customerid=""; lat; longi; isdigipinalreadyexist:boolean = false; digipin = "";
  updatedisdigipinalreadyexist:boolean = false; updateddigipin = "";
  updatedlat; updatedlongi;
  markerId: string;
  bmarkerId: string;

  center: any = {
    lat: 9.4515,
    lng: 77.5543,
  };
  
  digipinState: any = {
    location: ""
  }

  currentmeetingBusinessState: any = {
    location: ""
  }
  state: any = {
    businesslatitude: { value: "", iserr: false, err_txt: "" },
    businesslongitude: { value: "", iserr: false, err_txt: "" },
  }
  @Input() parentState: any = "";

  @Output() Submit_Event: EventEmitter<string> = new EventEmitter<string>();
  @Output() Pre_Submit_Event: EventEmitter<string> = new EventEmitter<string>();
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  

  constructor(private route: ActivatedRoute,private customerapi: CustomerService, private zone: NgZone,  public plt: Platform,
    private router: Router, private Winfoapi: CommonapiService,private custapi: CustomerapiService,
    private customerdetailserviceapi: CustomerDetailService) {

}

   async ngOnInit()
  {
    
    
  }
 

  async Show(customerid, lat, longi, isdigipinalreadyexist, digipin)
  {    
    this.customerid = customerid;
    this.lat = parseFloat(lat);
    this.longi = parseFloat(longi);
    this.isdigipinalreadyexist = isdigipinalreadyexist;
    this.updatedisdigipinalreadyexist = isdigipinalreadyexist;
    this.digipin = digipin;
    this.updateddigipin = digipin;
    this.updatedlat = this.lat;
    this.updatedlongi = this.longi;
    this.state.businesslatitude.value = "";
    this.state.businesslongitude.value = "";  
    this.isUseMyLocationClicked = false;
    this.divbeyondPopup = false;
    
      this.digipinState.location = await this.custapi.getLocation();
      if (this.digipinState.location.status == 1) {
          this.showLocationError = false;
          this.btnSaveDisableEnable = false;
          this._show = true;
          setTimeout(() => {
            this.Winfoapi.loader.startLoading();
              this.createMap();  
          });
      }
   
  }
 
async createMap() {
  this.zone.run(async () => {
    await GoogleMap.create({
      id: 'my-digipin-map',
      element: this.digipinmapRef.nativeElement,
      apiKey: environment.googleapimapkey, forceCreate: true,
      config: { center: this.center,     zoom: 14       },
    },(data1: any) => { 
    }).then(async (data:any)=>{
      this.digipinnewMap =data;
      await this.addListeners();
      // await this.addMarkerBusinessLocation(this.digipinState.location.lat, this.digipinState.location.long);
      await this.addMarkerBusinessLocation(this.lat, this.longi);
     
      console.log("Map initialized 1");
    });;
  }) 
  this.Winfoapi.loader.stopLoading();
} 

async addMarkerBusinessLocation(lat, lng) {
    // Add a marker to the map
    // if(this.markerId) this.removeMarker();
    let markerCountImageUrl = 'assets/images/location1.png';

    if (this.digipinnewMap) {
        this.bmarkerId = await this.digipinnewMap.addMarker({
          coordinate: {
            lat: lat,
            lng: lng,
          },
          iconUrl : markerCountImageUrl,
          //iconUrl : 'assets/images/location7.png',
          draggable: true,
          title: lat + ', ' + lng,

        });

        await this.digipinnewMap.setCamera({

          coordinate: {
            lat: lat,
            lng: lng
          }
        });


    }
    else
    {
      console.log('no map created');
    }
  }

 async removeMarker(ID) {
    // Add a marker to the map
    // if(this.markerId) this.removeMarker();
    
    await this.digipinnewMap.removeMarker(ID)

  }

   Callparentfunc(status, data:any = '') {
    this.CallParent.emit({status:status,data:data});
  }

  async Savedigipin()
  { 

      if(this.state.businesslatitude.value == "" || this.state.businesslatitude.value == "")
        {
          this.state.businesslatitude.value = this.lat;
          this.state.businesslongitude.value = this.longi;
        }

        var TrigonometryDistancekm =
                this.custapi.TrigonometryDistanceFromLatLonInKm(
                  this.state.businesslatitude.value +"", this.state.businesslongitude.value+"",
                  this.lat+"", this.longi+"")
              
        var TrigonometryDistanceMeter = TrigonometryDistancekm * 1000;
        
        if(TrigonometryDistanceMeter > 3) {
            this.showLocationError = false;
            this.btnSaveDisableEnable = false;
            this.divbeyondPopup = true;
        }
        else
        {
            this.showLocationError = false;
            this.btnSaveDisableEnable = false;
            this.divbeyondPopup = false;
            this.Save();
        }
    
  }
  
  async Save()
  {   

      var  _DIGIPIN = this.Get_DIGIPIN(this.state.businesslatitude.value.toString(),this.state.businesslongitude.value.toString());
      
        var postdata = {
            "digiPin": _DIGIPIN + "",
            "customerCode":  this.customerid + "",
            "latitude": this.state.businesslatitude.value+"", "longitude": this.state.businesslongitude.value+"",
          };        

        this.Winfoapi.loader.startLoading();
        await this.customerdetailserviceapi.addDigiPin(postdata, false).then(data => {
          
            if (data && data != undefined && data != '[]') {
              console.log("addDigiPin data", data)
                
              if (data.id > 0) {                  
                this.customerdetailserviceapi.api.Toast_success('DigiPin Successfully Added');
                this.updatedisdigipinalreadyexist = true;
                this.updateddigipin = _DIGIPIN + "";
                this.updatedlat = this.state.businesslatitude.value;
                this.updatedlongi = this.state.businesslongitude.value;
              }
              this.Winfoapi.loader.stopLoading();                  
            }
            else
            {
              this.Winfoapi.loader.stopLoading();                  
            }          

        })

      let _sdata = { digipin :this.updateddigipin , isdigipinalreadyexist: this.updatedisdigipinalreadyexist,
        latitude:this.updatedlat,longitude:this.updatedlongi
       };
    
      this.Callparentfunc(1,_sdata);
      this._show = false;
      this.Destroy();

  }

  async addListeners() {

    
    await this.digipinnewMap.setCamera({
        coordinate: {
          lat: this.lat,
          lng: this.longi
        }
      });

     


    await this.digipinnewMap.setOnMarkerClickListener((event) => {

    });

    await this.digipinnewMap.setOnMapClickListener((event) => {      

    });


    await this.digipinnewMap.setOnCameraIdleListener((event) => {     

    });

    await this.digipinnewMap.setOnCameraMoveStartedListener((event) => {
      
    });

    await this.digipinnewMap.setOnMarkerDragEndListener((event) => {
      console.log('setOnMarkerDragEndListener ' , event);
      this.removeMarker(event.markerId);
      this.addMarkerBusinessLocation(event.latitude,event.longitude);

      this.state.businesslatitude.value = event.latitude;
      this.state.businesslongitude.value = event.longitude;
      
      this.showLocationError = false;
      this.btnSaveDisableEnable = false;

    });

  }

  async digipin_setMyCurrentLocation()
  {
    this.currentmeetingBusinessState.location = await this.custapi.getLocation();
    
    if (this.currentmeetingBusinessState.location.status == 1) {
      this.state.businesslatitude.value = this.currentmeetingBusinessState.location.lat;
      this.state.businesslongitude.value = this.currentmeetingBusinessState.location.long;

      this.digipinnewMap.removeMarker(this.bmarkerId);
      this.addMarkerBusinessLocation(this.state.businesslatitude.value, this.state.businesslongitude.value);

      this.showLocationError = false;
      this.btnSaveDisableEnable = false;
      this.isUseMyLocationClicked = true;
      
    }
  }

  async addMarkerCurrentLocation(lat, lng) {
    // Add a marker to the map
    // if(this.markerId) this.removeMarker();
    let markerCountImageUrl = 'assets/images/location-icon-verybig.png';

    if (Capacitor.platform === 'web')
    {
      markerCountImageUrl = 'assets/images/location-icon.png';
    }

    if (this.digipinnewMap) {
        this.markerId = await this.digipinnewMap.addMarker({
          coordinate: {
            lat: lat,
            lng: lng,
          },
          iconUrl : markerCountImageUrl,
          //iconUrl : 'assets/images/location7.png',
          draggable: false,
          title: lat + ', ' + lng,

        });




    }
    else
    {
      console.log('no map created');
    }
  }

  BeyandCancel() {
    this.divbeyondPopup = false;
    this.Close();
  }

  BeyandYes() {
    this.divbeyondPopup = false;
    this.Save();    
  }

   Close() {
    
    this._show = false;
    this.Destroy();
    this.Callparentfunc(0);
  }

  ngOnDestroy() {
    
    console.log('map customer digipin destroy');
    this.Destroy();
  }
  
  Destroy()
  {
    if(this.digipinnewMap != undefined)
    {
      this.digipinnewMap.removeAllMapListeners();
      this.digipinnewMap.destroy();
      this.digipinnewMap = undefined;
    }
  }

  async ngAfterViewInit()  {
    
  }

  Get_DIGIPIN(lat, lon) {
 
      var L = [
          ['F', 'C', '9', '8'],
          ['J', '3', '2', '7'],
          ['K', '4', '5', '6'],
          ['L', 'M', 'P', 'T']
      ];
      var vDIGIPIN = '';

      //variable for identification of row and column of the cells
      var row = 0;
      var column = 0;
      // Bounding Box Extent
      var MinLat = 2.5;
      var MaxLat = 38.50;
      var MinLon = 63.50;
      var MaxLon =
          99.50;
      var LatDivBy = 4;
      var LonDivBy = 4;
      var LatDivDeg = 0;
      var LonDivDeg = 0;
      if (lat < MinLat || lat > MaxLat) {
          alert('Latitude Out of range');
          return '';
      }
      if (lon < MinLon || lon > MaxLon) {
          alert('Longitude Out of range');
          return '';
      }
      for (let Lvl = 1; Lvl <= 10; Lvl++) {
          LatDivDeg = (MaxLat - MinLat) / LatDivBy;
          LonDivDeg = (MaxLon - MinLon) / LonDivBy;
          var NextLvlMaxLat = MaxLat;
          var NextLvlMinLat = MaxLat - LatDivDeg;
          var x = 0;
          for (x = 0; x < LatDivBy; x++) {

              if (lat >= NextLvlMinLat && lat < NextLvlMaxLat) {
                  row = x;
                  break;
              } else {
                  NextLvlMaxLat = NextLvlMinLat
                  NextLvlMinLat = NextLvlMaxLat - LatDivDeg;
              } 
          }

          var NextLvlMinLon = MinLon;
          var NextLvlMaxLon = MinLon + LonDivDeg;
          for (x = 0; x < LonDivBy; x++) {
              if (lon >= NextLvlMinLon && lon < NextLvlMaxLon) {
                  column = x;
                  break;
              } else if ((NextLvlMinLon + LonDivDeg) < MaxLon) {  
                  NextLvlMinLon = NextLvlMaxLon;
                  NextLvlMaxLon = NextLvlMinLon + LonDivDeg;
              } else {
                  column = x;
              }
          }

          if (Lvl == 1) {
              if (L[row][column] == "0") {
                  vDIGIPIN = "Out of Bound";
                  break;
              }
          }
          vDIGIPIN = vDIGIPIN + L[row][column];


          if (Lvl == 3 || Lvl == 6) {
              vDIGIPIN = vDIGIPIN + "-"
          }

  
          MinLat = NextLvlMinLat;
          MaxLat = NextLvlMaxLat;
          MinLon = NextLvlMinLon;
          MaxLon = NextLvlMaxLon;
      }
      return vDIGIPIN;
    }
}
